import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmployeeDetailsService } from 'src/app/_services/employee-details.service';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Map, NavigationControl, Marker } from "maplibre-gl";
import maplibregl from "maplibre-gl";
import * as FileSaver from 'file-saver'; 
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs'; 

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';  
const EXCEL_EXTENSION = '.xlsx'; 


@Component({
  selector: 'app-monthly-attendance',
  templateUrl: './monthly-attendance.component.html',
  styleUrls: ['./monthly-attendance.component.scss']
})
export class MonthlyAttendanceComponent implements OnInit {

  formAttendance: any;
  //dataSource:any
  codes: any;
  displayedColumns: string[] = ['#', 'employeecode', 'date', 'in-time', 'out-time', 'tot-working'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @ViewChild(MatTable, { static: true }) table: MatTable<any> = Object.create(null);
  maxDate = new Date();
  constructor(
    private employeeDetails: EmployeeDetailsService,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {}
  excel:any;  
  //result : string[] = [];
  ngOnInit(): void {
    this.formAttendance = new FormGroup({
      code: new FormControl("", []),
      from_date: new FormControl("", [Validators.required]),
      to_date: new FormControl("", [Validators.required]),
    });
    this.employeeDetails.getEmployeeDetails().subscribe(
      (response: any) => {
        if (response && response.msg && Array.isArray(response.msg)) {
          this.codes = response.msg;
          console.log(this.codes);
        }
      },
      (error: any) => {
        console.error("Error fetching employee details:", error);
      }
    );
  }

    onSubmit() {
    if(this.formAttendance.valid){
      this.formAttendance.value.from_date = this.datePipe.transform(
        this.formAttendance.value.from_date,
        "yyyy-MM-dd"
      );
      this.formAttendance.value.to_date = this.datePipe.transform(
        this.formAttendance.value.to_date,
        "yyyy-MM-dd"
      );
      this.excel = [];
      this.employeeDetails.getMonthlyAttendance(this.formAttendance.value).subscribe(
        (res)=>{
          //console.log(res)
          let result = res['msg'];

          this.excel = [...result]
          this.dataSource = new MatTableDataSource(res.msg);
          this.dataSource.paginator = this.paginator;
        }
      )
    }
    }
    openDialog(action: string) {
      console.log(action)
      const dialogRef = this.dialog.open(EmployeeDialogContent, {
          data: action
        
      });
 
    }
    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
    }
    exportExcel():void{
      this.exportreportExcelFile( this.excel,'monthly_attendance_details');
    }
    public exportreportExcelFile(json: any[], excelFileName: string): void {  
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);  
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };  
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });  
      this.saveAsExcelFile(excelBuffer, excelFileName);  
    }  
    private saveAsExcelFile(buffer: any, fileName: string): void {  
       const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});  
       let currentDateAndTime = this.datePipe.transform(new Date(), 'yyyy-MM-dd-HH:mm:ss');
       FileSaver.saveAs(data, fileName + '_export_' + currentDateAndTime + EXCEL_EXTENSION);  
    }  


}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'dialog-content',
  templateUrl: 'dialog-content.html',
  styleUrls:['dialog-content.scss']
})
// tslint:disable-next-line: component-class-suffix
export class EmployeeDialogContent {
  map: Map | undefined;
  @ViewChild("map")
  private mapContainer!: ElementRef<HTMLElement>;
  local_data: any;

  constructor(
      public dialogRef: MatDialogRef<EmployeeDialogContent>,
      // @Optional() is used to prevent error if no data is passed
      @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
       console.log(data);
      this.local_data = data;
  
  }

  ngAfterViewInit(){
    const initialState = { lng: 80.2707, lat: 13.0827, zoom: 10 };

    this.map = new Map({
      container: this.mapContainer.nativeElement,
      style: `https://api.maptiler.com/maps/streets-v2/style.json?key=rfbtBDxb0VjtfmJzd4VA`,
      center: [initialState.lng, initialState.lat],
      zoom: initialState.zoom,
      maxZoom:30
    });
    this.map?.addControl(new NavigationControl(), 'top-right');
    if (!isNaN(this.local_data.CheckInLat) && !isNaN(this.local_data.CheckInLong) ) {
                
      const lngLat1: [number, number] = [parseFloat(this.local_data.CheckInLong), parseFloat(this.local_data.CheckInLat)];
      const lngLat2: [number, number] = [parseFloat(this.local_data.CheckOutLong?this.local_data.CheckOutLong:0), parseFloat(this.local_data.CheckOutLat?this.local_data.CheckOutLat:0)];
  
      let markerColor1 =  '#FF0000' ;
      let markerColor2 =  '#0000FF' ;
            // Create popup instances for each marker
            const popup1 = new maplibregl.Popup({ offset: [0, -10] });
            const popup2 = new maplibregl.Popup({ offset: [0, -10] });
        
      // Add marker to the map with the LngLat object
      const marker1 = new maplibregl.Marker({ color: markerColor1 })
          .setLngLat(lngLat1)
       
          .addTo(this.map!);
  
      const marker2 = new maplibregl.Marker({ color: markerColor2 })
          .setLngLat(lngLat2)
       
          .addTo(this.map!);
  

  
      // Add mouseenter event listener to show popup for marker1
      marker1.getElement().addEventListener('mouseenter', () => {
        if (this.map && this.map.getCanvas()) {
            this.map.getCanvas().style.cursor = 'pointer';
        }
        if(this.local_data.CheckIn!==null && this.local_data.CheckOut!==null){  
          popup1.setLngLat(lngLat1).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong>`).addTo(this.map!);
        }else{
          if(this.local_data.CheckOut!=null){
            popup1.setLngLat(lngLat1).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong><br><strong>Check-out:${this.local_data.CheckOut}</strong>`).addTo(this.map!);
          }else{
            popup1.setLngLat(lngLat1).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong>`).addTo(this.map!);
          }
          //popup1.setLngLat(lngLat1).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong><br><strong>Check-out:${this.local_data.CheckOut}</strong>`).addTo(this.map!);
        }
    });
  
      // Add mouseleave event listener to remove popup for marker1
      marker1.getElement().addEventListener('mouseleave', () => {
          if (this.map && this.map.getCanvas()) {
              this.map.getCanvas().style.cursor = '';
          }
  
          popup1.remove();
      });
  
      // Add mouseenter event listener to show popup for marker2
      marker2.getElement().addEventListener('mouseenter', () => {
        if (this.map && this.map.getCanvas()) {
            this.map.getCanvas().style.cursor = 'pointer';
        }
        if(this.local_data.CheckOut!=null && this.local_data.CheckIn!=null){  
          popup2.setLngLat(lngLat2).setHTML(`<strong>Check-out:${this.local_data.CheckOut}</strong>`).addTo(this.map!);
        }else{
          if(this.local_data.CheckOut!=null){
            popup2.setLngLat(lngLat2).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong><br><strong>Check-out:${this.local_data.CheckOut}</strong>`).addTo(this.map!);
          }else{
            popup2.setLngLat(lngLat2).setHTML(`<strong>Check-in:${this.local_data.CheckIn}</strong>`).addTo(this.map!);
          }
          
        }
        
    });
  
      // Add mouseleave event listener to remove popup for marker2
      marker2.getElement().addEventListener('mouseleave', () => {
          if (this.map && this.map.getCanvas()) {
              this.map.getCanvas().style.cursor = '';
          }
  
          popup2.remove();
      });
  }
  
  
    // if (!isNaN(this.local_data.CheckOutLat) && !isNaN(this.local_data.CheckOutLong)) {
                
    //   const lngLat: [number, number] = [parseFloat(this.local_data.CheckOutLong), parseFloat(this.local_data.CheckOutLat)];

    
    //   let markerColor =  '#0000ff' ;
      
    
      

    //   // Add marker to the map with the LngLat object
    //   const marker = new maplibregl.Marker({ color: markerColor })
    //     .setLngLat(lngLat)
    //     .addTo(this.map!)

      
    
    //   // Create a popup instance
    //   const popup = new maplibregl.Popup({ offset: [0, -10] });

    //   // Add mouseenter event listener to show popup
    //   marker.getElement().addEventListener('mouseenter', () => {
    //     if (this.map && this.map.getCanvas()) {
    //       this.map.getCanvas().style.cursor = 'pointer';
    //     }

    //     popup.setLngLat(lngLat).setHTML(`<strong>${this.local_data.CheckOut}</strong>`).addTo(this.map!);
    //   });

    //   // Add mouseleave event listener to remove popup
    //   marker.getElement().addEventListener('mouseleave', () => {
    //     if (this.map && this.map.getCanvas()) {
    //       this.map.getCanvas().style.cursor = '';
    //     }

    //     popup.remove();
    //   });
    // }
  }

  doAction() {
      this.dialogRef.close({ data: this.local_data });
  }

  closeDialog() {
      this.dialogRef.close({ event: 'Cancel' });
  }

}

